import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import { cn } from '@/lib/utils';

// Разрешаем нативные раскрывающиеся блоки <details>/<summary> в контенте
// (напр. «Урок 0»). rehype-sanitize вырезает всё опасное (<script>, onerror и т.п.),
// поэтому raw-HTML в bodyMd безопасен даже от админа/LLM.
const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames ?? []), 'details', 'summary'],
};

interface Props {
  children: string;
  className?: string;
  /** Запрет выделения текста (для защищённого внутреннего контента) */
  noSelect?: boolean;
}

export function Markdown({ children, className, noSelect }: Props) {
  return (
    <div className={cn('prose-tg', noSelect && 'no-select', className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, sanitizeSchema]]}
        components={{
          // Wrap markdown tables в horizontal-scroll контейнер — иначе на
          // узких экранах TG WebApp (~360px) длинные таблицы вылезают за рамки
          // или ломают layout. Внутри table — обычный border-collapse с границами
          // (см. .prose-tg table в globals.css).
          table: ({ children: tChildren, ...props }) => (
            <div className="md-table-wrap">
              <table {...props}>{tChildren}</table>
            </div>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
